var _g, _ellipse, _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncompatibleVicki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 139,
    viewBox: "0 0 226 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.845 35.5127H202.695C202.695 35.5127 220.156 42.7213 220.156 69.9286C220.156 97.1359 206.03 103.82 206.03 103.82H189.739L185.845 35.5127Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.201 36.5103H188.202V37.945H203.201V36.5103Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.09 42.3018H189.652V43.7365H208.09V42.3018Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.303 47.5332H189.442V48.9679H211.303V47.5332Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.034 71.7661H192.899V73.2008H220.034V71.7661Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.178 79.1494H192.044V80.5841H219.178V79.1494Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.973 84.2412H190.839V85.6759H217.973V84.2412Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.057 89.6123H189.407V91.047H215.057V89.6123Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.845 104.485C191.853 104.485 196.723 89.4287 196.723 70.8561C196.723 52.2836 191.853 37.2275 185.845 37.2275C179.837 37.2275 174.967 52.2836 174.967 70.8561C174.967 89.4287 179.837 104.485 185.845 104.485Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.036 11C164.036 11 192.899 16.4064 194.261 72.8157C194.261 72.8157 194.261 122.471 169.152 128.805L48.1304 130.765V13.9219L164.036 11Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8669 14.2716L109.209 12.627L52.3209 20.0105L51.8669 14.2716Z",
    fill: "#A0A0A0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1404 19.346C67.4773 18.7861 77.8666 18.0513 88.2209 17.1239C98.5753 16.1966 108.912 15.1293 119.162 13.3271C109.104 16.0741 98.8546 18.0863 88.605 19.9759C78.3554 21.8656 68.0535 23.4753 57.6991 25.0675L57.1404 19.346Z",
    fill: "#A0A0A0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8198 25.6097C72.1742 25.0323 82.5635 24.3149 92.9004 23.3876C103.237 22.4602 113.592 21.393 123.859 19.5908C113.801 22.3203 103.552 24.3499 93.2846 26.2395C83.0175 28.1292 72.733 29.7389 62.3786 31.3311L61.8198 25.6097Z",
    fill: "#A0A0A0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6975 25.6271C75.6663 24.1341 89.6351 22.5419 103.604 20.8506L124.47 18.1386C131.454 17.1937 138.439 16.1789 145.248 14.8667C138.456 16.6164 131.594 18.1211 124.714 19.5558L104.04 23.685C90.2462 26.3212 76.4288 28.864 62.588 31.3136L61.6975 25.6271Z",
    fill: "#A0A0A0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.469 35.6527C79.0304 33.9614 92.5918 32.0717 106.153 29.9838C112.928 28.9457 119.685 27.8142 126.425 26.5894C133.165 25.3472 139.888 24.0349 146.506 22.1978C140.028 24.4898 133.375 26.292 126.722 27.9891C120.07 29.6863 113.4 31.296 106.694 32.8182C93.2844 35.8393 79.8394 38.6796 66.3595 41.3391L65.469 35.6527Z",
    fill: "#A0A0A0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3201 48.058C81.8651 45.346 96.4275 42.4591 110.973 39.3097C118.213 37.7583 125.442 36.1078 132.659 34.3582C139.871 32.6085 147.047 30.7713 154.101 28.4268C147.222 31.2262 140.132 33.5183 133.043 35.7404C125.954 37.9624 118.813 40.0795 111.671 42.0917C97.353 46.1509 82.9885 50.0002 68.5773 53.6395L67.3201 48.058Z",
    fill: "#A0A0A0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9788 62.2304C76.6965 61.0231 84.4492 59.6058 92.1495 58.1011C99.8498 56.5964 107.55 54.9342 115.181 53.0796C122.811 51.2249 130.424 49.2479 137.88 46.8858C145.422 44.6261 152.792 41.8252 159.933 38.5049C152.984 42.2732 145.771 45.5303 138.351 48.2505C130.965 51.0675 123.457 53.4995 115.896 55.8441C108.336 58.1886 100.723 60.3057 93.0749 62.3004C85.427 64.295 77.7966 66.2196 69.9915 67.9693L68.9788 62.2304Z",
    fill: "#A0A0A0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0486 77.0324C77.4997 75.8601 86.0206 74.3555 94.4368 72.6933C102.853 71.0311 111.287 69.1939 119.633 66.9893C136.291 62.6327 152.809 57.3837 168.244 49.4927C153.245 58.1535 136.919 64.3649 120.436 69.6839C112.16 72.3084 103.796 74.6704 95.3972 76.84C86.9984 79.0096 78.5473 80.9517 69.939 82.6314L69.0486 77.0324Z",
    fill: "#A0A0A0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4597 91.5024C76.3823 90.2252 85.3573 88.633 94.2624 86.8833C103.168 85.1336 112.055 83.174 120.855 80.8995C129.656 78.6249 138.421 76.1928 147.047 73.2534C155.687 70.3503 164.112 66.8423 172.261 62.7554C164.304 67.2603 156.042 71.201 147.536 74.5482C139.05 77.96 130.372 80.8644 121.659 83.6114C112.946 86.3584 104.093 88.7554 95.2227 91.03C86.3525 93.3046 77.4475 95.3342 68.4027 97.1363L67.4597 91.5024Z",
    fill: "#A0A0A0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4739 103.768C73.6234 102.963 82.8602 101.79 92.0098 100.461C101.159 99.1309 110.326 97.5387 119.389 95.5965C128.451 93.6544 137.496 91.5373 146.348 88.7553C155.251 86.0991 163.914 82.6925 172.243 78.5723C164.105 83.138 155.594 87.0012 146.802 90.1201C138.072 93.3745 129.062 95.9465 120.052 98.396C111.042 100.846 101.91 102.84 92.7432 104.695C83.5762 106.549 74.4091 108.194 65.0675 109.489L64.4739 103.768Z",
    fill: "#A0A0A0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.353 114.178C69.974 113.566 79.6649 112.586 89.2859 111.449C98.9069 110.311 108.493 108.929 118.114 107.214C137.199 103.715 156.249 99.4284 174.251 91.9048C156.633 100.303 137.688 105.64 118.673 110.049C109.139 112.218 99.4656 114.056 89.9145 115.718C80.3633 117.38 70.7074 118.797 60.8245 119.899L60.353 114.178Z",
    fill: "#A0A0A0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5513 121.212C65.5739 120.757 75.6664 119.969 85.7064 119.042C95.7465 118.115 105.804 116.978 115.809 115.543C135.785 112.691 155.742 109.034 174.967 102.595C156.057 109.944 136.186 114.563 116.263 118.342C106.293 120.249 96.2703 121.842 86.2128 123.276C76.1552 124.711 66.0977 125.936 55.918 126.898L55.5513 121.212Z",
    fill: "#A0A0A0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6447 124.763C60.5625 125.236 70.6201 125.323 80.6253 125.201C90.6304 125.078 100.67 124.693 110.658 123.923C130.633 122.349 150.661 119.689 169.781 113.425C150.976 120.669 130.93 124.308 110.955 126.845C100.932 128.105 90.8748 128.945 80.7824 129.575C70.6899 130.205 60.6499 130.572 50.4526 130.572L50.6447 124.763Z",
    fill: "#A0A0A0",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1479 130.695C62.0248 130.695 73.2742 104.554 73.2742 72.3083C73.2742 40.0624 62.0248 13.9219 48.1479 13.9219C34.2709 13.9219 23.0215 40.0624 23.0215 72.3083C23.0215 104.554 34.2709 130.695 48.1479 130.695Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5066 42.8787C47.0081 42.8787 47.4146 42.1894 47.4146 41.339C47.4146 40.4887 47.0081 39.7993 46.5066 39.7993C46.0051 39.7993 45.5986 40.4887 45.5986 41.339C45.5986 42.1894 46.0051 42.8787 46.5066 42.8787Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8096 87.6006H35.9078V73.8832H40.535V65.6072H37.0428C36.8541 65.6096 36.6669 65.574 36.4921 65.5028C36.3173 65.4315 36.1585 65.3259 36.0251 65.1922C35.8917 65.0585 35.7863 64.8995 35.7152 64.7243C35.6441 64.5492 35.6086 64.3615 35.6109 64.1725C35.6109 63.792 35.7618 63.4271 36.0303 63.158C36.2988 62.889 36.663 62.7378 37.0428 62.7378H43.4161V76.7351H38.7889V84.6961H41.8271C42.0157 84.6938 42.2029 84.7293 42.3777 84.8005C42.5525 84.8718 42.7113 84.9774 42.8447 85.1111C42.9782 85.2448 43.0835 85.4039 43.1546 85.579C43.2258 85.7541 43.2612 85.9418 43.2589 86.1308C43.2636 86.3237 43.2294 86.5155 43.1585 86.6948C43.0875 86.8741 42.9813 87.0372 42.846 87.1744C42.7107 87.3116 42.5492 87.42 42.3711 87.4932C42.193 87.5665 42.002 87.603 41.8096 87.6006Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3211 87.6006H45.4192V73.8832H50.0464V65.6072H46.5542C46.3656 65.6096 46.1783 65.574 46.0036 65.5028C45.8288 65.4315 45.67 65.3259 45.5366 65.1922C45.4031 65.0585 45.2978 64.8995 45.2267 64.7243C45.1555 64.5492 45.1201 64.3615 45.1224 64.1725C45.1224 63.792 45.2733 63.4271 45.5418 63.158C45.8103 62.889 46.1745 62.7378 46.5542 62.7378H52.9275V76.7351H48.3003V84.6961H51.3385C51.5272 84.6938 51.7144 84.7293 51.8892 84.8005C52.064 84.8718 52.2228 84.9774 52.3562 85.1111C52.4896 85.2448 52.595 85.4039 52.6661 85.579C52.7372 85.7541 52.7727 85.9418 52.7703 86.1308C52.7751 86.3237 52.7409 86.5155 52.67 86.6948C52.599 86.8741 52.4928 87.0372 52.3575 87.1744C52.2222 87.3116 52.0607 87.42 51.8826 87.4932C51.7045 87.5665 51.5135 87.603 51.3211 87.6006Z",
    fill: "#A0A0A0"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 103.597,
    cy: 131.173,
    rx: 103.597,
    ry: 7.82734,
    fill: "url(#paint0_radial_0_1)",
    fillOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 196.5,
    cy: 29.5,
    r: 29.5,
    fill: "#DD341D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.517 29.5002L207.967 23.0502C209.4 21.6168 209.4 19.4668 207.967 18.0335C206.533 16.6002 204.383 16.6002 202.95 18.0335L196.5 24.4835L190.05 18.0335C188.617 16.6002 186.467 16.6002 185.033 18.0335C183.6 19.4668 183.6 21.6168 185.033 23.0502L191.483 29.5002L185.033 35.9502C183.6 37.3835 183.6 39.5335 185.033 40.9668C185.75 41.6835 186.646 42.0418 187.542 42.0418C188.437 42.0418 189.333 41.6835 190.05 40.9668L196.5 34.5168L202.95 40.9668C203.667 41.6835 204.562 42.0418 205.458 42.0418C206.354 42.0418 207.25 41.6835 207.967 40.9668C209.4 39.5335 209.4 37.3835 207.967 35.9502L201.517 29.5002Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_0_1",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.597 131.173) rotate(90) scale(7.82734 103.597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 197.065,
    height: 119.712,
    fill: "white",
    transform: "translate(23.0215 11)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompatibleVicki);
export default __webpack_public_path__ + "static/media/incompatible-vicki.94ae73f4f9b7914c46823f8873966857.svg";
export { ForwardRef as ReactComponent };